// extracted by mini-css-extract-plugin
export default {"container":"TextLabel_container__8eNed","verticalAlign":"TextLabel_verticalAlign__6RJHv","flexContainer":"TextLabel_flexContainer__OrdR2"};